import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "modal__content" }
const _hoisted_2 = { class: "block__content" }
const _hoisted_3 = { class: "members__selector" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Assign Members", -1)
const _hoisted_5 = { class: "members_text" }
const _hoisted_6 = { class: "members__img" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "tw-flex tw-flex-col" }
const _hoisted_9 = { class: "tw-text-red-600" }

import UserProfileLogo from "@/core/components/UserProfileLogo.vue";
import CommonDialog from "@/core/components/CommonDialog.vue";
import {
  displayToastMessage,
  getImageStringToImageURL,
} from "@/core/utils/common";
import { MEMBER_STORE } from "@/store/modules/manage-member";
import { USER_STORE } from "@/store/modules/user";
import {
  computed,
  getCurrentInstance,
  onBeforeMount,
  onMounted,
  ref,
} from "vue";
import { useStore } from "vuex";
import { COURSES_STORE } from "@/store/modules/courses";
import { MemberInvitationStatusEnum } from "@/core/enums/RolesEnum";
import coursesService from "@/core/services/courses.service";
import CheckElegibilityForAssignCourseModal from "./CheckElegibilityForAssignCourseModal.vue";
import AddTeamMemberModal from "@/modules/trade-passport/components/AddTeamMemberModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AssignCourseSlotToMemberModal',
  props: {
  selectedUserCourseIdForAssign: {
    type: [Number, null],
    required: true,
    default: null,
  },
  isfromCourseModule: {
    type: Boolean,
    required: true,
  },
},
  emits: ["onClickCloseButton", "memberInvited"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const emit = __emit;
const teamMemberList = ref();
const props = __props;
const eligibility = ref(null);
const isShowElegibilityModal = ref(false);
const isShowCourseAssignModal = ref(true);
const isOpenedAddMemberModel = ref(false);
const internalInstance = getCurrentInstance();
const errorAlert = ref("");
const user = computed(() => store.getters[`${USER_STORE}/user`]);
const assignedMembers = ref([]);
const coursesWithRemainingSlots = computed(
  () => store.getters[`${COURSES_STORE}/getCoursesWithRemainingSlots`]
);
const listOfEnrollCourse = computed(
  () => store.getters[`${COURSES_STORE}/getEnrollCourses`]
);
const isLoading = ref(false);
const isMemberLoading = ref(true);
const userSelectedCourseForAssign = ref();
const setTeamMember = async () => {
  try {
    let response = await store.dispatch(`${MEMBER_STORE}/getTeamMember`, {
      userId: user.value?.id,
    });

    response = response.filter(
      (member: any) =>
        member?.invitationStatus === MemberInvitationStatusEnum.ACCEPTED
    );
    for (const member of response) {
      if ("toUser" in member) {
        member["profileImage"] = await getImageStringToImageURL(
          member?.toUser?.userPublicProfile?.profileImage
        );
      } else {
        member["profileImage"] = await getImageStringToImageURL(
          member?.userWorkstation?.profileImage
        );
      }
    }

    teamMemberList.value = response;
  } catch (err) {
    console.log();
  }
};

const setAlreadyAssignedMember = (userCourseLists: any) => {
  userSelectedCourseForAssign.value = userCourseLists.find(
    (course: any) => course?.id == props.selectedUserCourseIdForAssign
  );
  assignedMembers.value = userSelectedCourseForAssign.value?.allocatedSlots.map(
    (allocatedSlot: any) => allocatedSlot?.user?.id
  );
  isMemberLoading.value = false;
};

const onClickCloseButton = () => {
  emit("onClickCloseButton");
};

const onClickAssignMember = async () => {
  try {
    isLoading.value = true;
    const response = await store.dispatch(
      `${COURSES_STORE}/assignUserCourseToMember`,
      {
        userId: user.value?.id,
        userCourseId: userSelectedCourseForAssign.value?.id,
        memberIds: assignedMembers.value,
      }
    );
    if (!props.isfromCourseModule) {
      store.dispatch(`${COURSES_STORE}/getCoursesWithRemainingSlots`, {
        userId: user.value.id,
      });
    } else {
      store.dispatch(`${COURSES_STORE}/getEnrollCourses`, {
        userId: user.value.id,
      });
    }
    displayToastMessage(internalInstance, response?.message, "success");
    onClickCloseButton();
  } catch (error: any) {
    console.log();
    errorAlert.value = error?.response?.data?.message;
  } finally {
    isLoading.value = false;
  }
};

const onUpdateAssignMember = async (newVal: any) => {
  try {
    isMemberLoading.value = true;
    errorAlert.value = "";
    if (newVal[newVal?.length - 1]) {
      const response: any =
        await coursesService.checkElegibilityForAssignMember(
          userSelectedCourseForAssign.value?.course?.id,
          newVal[newVal?.length - 1]
        );
      if (!response?.isEligible) {
        eligibility.value = response;
        isShowElegibilityModal.value = true;
        assignedMembers.value.pop();
      }
    }
  } catch (error) {
    console.log(error);
    newVal.pop();
  } finally {
    isMemberLoading.value = false;
  }
};

const onCloseElegibilityForAssignCourseModal = () => {
  eligibility.value = null;
  isShowElegibilityModal.value = false;
};

const onClickCloseAddMemberModel = (isMemberAdded = false) => {
  if (isMemberAdded) {
    emit("memberInvited");
  }
  isOpenedAddMemberModel.value = false;
};
const openAddMemberModal = () => {
  isOpenedAddMemberModel.value = true;
};
onBeforeMount(async () => {
  await setTeamMember();
  if (!props.isfromCourseModule) {
    setAlreadyAssignedMember(coursesWithRemainingSlots.value);
  } else {
    setAlreadyAssignedMember(listOfEnrollCourse.value);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isShowCourseAssignModal.value)
      ? (_openBlock(), _createBlock(CommonDialog, {
          key: 0,
          onClickBackButton: onClickCloseButton,
          isShowHeader: true,
          isShowBackButton: true,
          width: "575px",
          "max-width": "100%",
          height: "auto",
          className: ['assign_course__modal_box']
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h5", null, " Total: " + _toDisplayString(userSelectedCourseForAssign.value?.selectedSpotCount) + " Spots ", 1),
                _createElementVNode("p", null, [
                  _createTextVNode(" Members can now be assigned to the "),
                  _createElementVNode("b", null, _toDisplayString(userSelectedCourseForAssign.value?.selectedSpotCount -
                userSelectedCourseForAssign.value?.allocatedSlots?.length || 0), 1),
                  _createTextVNode(" available spots in the " + _toDisplayString(userSelectedCourseForAssign.value?.course?.name) + ". ", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_v_autocomplete, {
                  variant: "outlined",
                  label: "Select team member",
                  "bg-color": "#fff",
                  chips: "",
                  class: "input_field input_dropdown",
                  color: "blue-grey-lighten-2",
                  "closable-chips": "",
                  items: teamMemberList.value,
                  "item-title": "toUserId",
                  "item-value": "toUserId",
                  multiple: "",
                  loading: isMemberLoading.value,
                  modelValue: assignedMembers.value,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((assignedMembers).value = $event)),
                    onUpdateAssignMember
                  ],
                  "menu-props": { contentClass: 'members__selector__dropdown' }
                }, {
                  chip: _withCtx(({ props, item }) => [
                    _createVNode(_component_v_chip, _mergeProps(props, {
                      "prepend-avatar": item.raw.avatar,
                      text: item.raw.email
                    }), null, 16, ["prepend-avatar", "text"])
                  ]),
                  item: _withCtx(({ props, item }) => [
                    _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("h6", null, _toDisplayString(item.raw?.toUser?.firstName) + " " + _toDisplayString(item.raw?.toUser?.lastName), 1),
                          _createElementVNode("p", null, _toDisplayString(item.raw.email), 1)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          (item.raw.profileImage)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: item.raw.profileImage
                              }, null, 8, _hoisted_7))
                            : (_openBlock(), _createBlock(UserProfileLogo, {
                                key: 1,
                                userName: item.raw?.userName
                              }, null, 8, ["userName"]))
                        ]),
                        _createVNode(_component_v_checkbox, {
                          disabled: "",
                          modelValue: assignedMembers.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((assignedMembers).value = $event)),
                          value: item.raw.toUserId,
                          color: "indigo-darken-3"
                        }, null, 8, ["modelValue", "value"])
                      ]),
                      _: 2
                    }, 1040)
                  ]),
                  _: 1
                }, 8, ["items", "loading", "modelValue"]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(errorAlert.value), 1),
                  _createElementVNode("a", {
                    onClick: _withModifiers(openAddMemberModal, ["prevent"]),
                    class: "tw-cursor-pointer tw-text-[#FFA500] tw-flex tw-items-center"
                  }, [
                    _createTextVNode("Invite Members "),
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-chevron-right")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_component_v_btn, {
                  onClick: onClickAssignMember,
                  loading: isLoading.value,
                  disabled: isLoading.value || isMemberLoading.value,
                  class: "button button-orange",
                  width: "100%"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Assign Members")
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"]),
                _createVNode(_component_v_btn, {
                  variant: "plain",
                  color: "#4F55F0",
                  class: "blue-text",
                  onClick: onClickCloseButton
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("close")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (isShowElegibilityModal.value)
      ? (_openBlock(), _createBlock(CheckElegibilityForAssignCourseModal, {
          key: 1,
          eligibility: eligibility.value,
          userCourseId: userSelectedCourseForAssign.value?.course?.id,
          onOnClose: onCloseElegibilityForAssignCourseModal
        }, null, 8, ["eligibility", "userCourseId"]))
      : _createCommentVNode("", true),
    (isOpenedAddMemberModel.value)
      ? (_openBlock(), _createBlock(AddTeamMemberModal, {
          key: 2,
          userCourseId: userSelectedCourseForAssign.value?.id,
          onOnClickCloseTab: onClickCloseAddMemberModel
        }, null, 8, ["userCourseId"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})